const o = (e, r = "&:hover") => ({
  "@media (hover: hover)": {
    [r]: {
      ...e
    }
  }
});
export {
  o as hover
};
